"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSiteSaga = getSiteSaga;
exports.getSitesSaga = getSitesSaga;
exports.makeSiteApproveSaga = makeSiteApproveSaga;
var _effects = require("redux-saga/effects");
var _paulCorePackage = require("paul-core-package");
var _api = require("../../utils/api");
var _functions = require("../../utils/functions");
var _constants = require("../../utils/constants");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function* getSitesSaga(_ref) {
  let {
    type
  } = _ref;
  try {
    const token = yield (0, _effects.select)(_paulCorePackage.selectors.getToken);
    const {
      api: apiURL
    } = yield (0, _effects.select)(_paulCorePackage.selectors.getUrls);
    yield (0, _effects.call)(_functions.throwErrorIfIsNotCondition, apiURL, 'Empty URL');
    const response = yield (0, _effects.call)(_api.getAPISites, {
      prefUrl: apiURL,
      token
    });
    const parseResp = yield (0, _effects.call)(() => response.json());
    yield (0, _effects.call)(_functions.throwErrorIfIsNotCondition, response.ok, parseResp.message);
    yield (0, _effects.put)((0, _paulCorePackage.requestSuccess)(type, parseResp));
  } catch (error) {
    /** add error handler */
    yield (0, _effects.call)(() => console.log('catch', error, type));
    yield (0, _effects.put)((0, _paulCorePackage.requestError)(type, {
      message: error.formError
    }));
  }
}
function* getSiteSaga(_ref2) {
  let {
    type,
    payload: {
      siteId
    }
  } = _ref2;
  try {
    const token = yield (0, _effects.select)(_paulCorePackage.selectors.getToken);
    const {
      api: apiURL
    } = yield (0, _effects.select)(_paulCorePackage.selectors.getUrls);
    yield (0, _effects.call)(_functions.throwErrorIfIsNotCondition, apiURL, 'Empty URL');
    const response = yield (0, _effects.call)(_api.getAPISite, {
      prefUrl: apiURL,
      token,
      siteId
    });
    const parseResp = yield (0, _effects.call)(() => response.json());
    yield (0, _effects.call)(_functions.throwErrorIfIsNotCondition, response.ok, parseResp.message);
    yield (0, _effects.put)((0, _paulCorePackage.requestSuccess)(type, parseResp));
  } catch (error) {
    /** add error handler */
    yield (0, _effects.call)(() => console.log('catch', error, type));
    yield (0, _effects.put)((0, _paulCorePackage.requestError)(type, {
      message: error.formError
    }));
  }
}
function* makeSiteApproveSaga(_ref3) {
  let {
    type,
    payload: {
      siteId
    }
  } = _ref3;
  try {
    const token = yield (0, _effects.select)(_paulCorePackage.selectors.getToken);
    const {
      api: apiURL
    } = yield (0, _effects.select)(_paulCorePackage.selectors.getUrls);
    yield (0, _effects.call)(_functions.throwErrorIfIsNotCondition, apiURL, 'Empty URL');
    const response = yield (0, _effects.call)(_api.makeAPISiteApprove, {
      prefUrl: apiURL,
      token,
      siteId
    });
    const parseResp = yield (0, _effects.call)(() => response.json());
    yield (0, _effects.call)(_functions.throwErrorIfIsNotCondition, response.ok, parseResp.message);
    yield (0, _effects.delay)(_constants.startSiteTime);
    yield (0, _effects.put)((0, _paulCorePackage.requestSuccess)(type, _objectSpread(_objectSpread({}, parseResp), {}, {
      siteId
    })));
  } catch (error) {
    /** add error handler */
    yield (0, _effects.call)(() => console.log('catch', error, type));
    yield (0, _effects.put)((0, _paulCorePackage.requestError)(type, {
      message: error.formError
    }));
  }
}